import { MutationTree } from 'vuex';
import { IDocumentActionsState } from './document-actions.types';
import { EDocumentActionsMutation } from './document-actions.constants';
import { ISentEmail } from '@/document-actions/types/sent-email';
import { IDocument } from '@lib-shared/types/Document';
import { IDocumentEventItem } from '@/document-view/types/document-events-item';

export const mutations: MutationTree<IDocumentActionsState> = {
  [EDocumentActionsMutation.SetState](
    state: IDocumentActionsState,
    newState: IDocumentActionsState
  ) {
    Object.assign(state, newState);
  },
  [EDocumentActionsMutation.SetLoading](state: IDocumentActionsState, loading: boolean) {
    state.loading = loading;
  },
  [EDocumentActionsMutation.SetError](state: IDocumentActionsState, error: boolean) {
    state.error = error;
  },
  [EDocumentActionsMutation.SetDone](state: IDocumentActionsState, done: boolean) {
    state.done = done;
  },
  [EDocumentActionsMutation.SetDocument](state: IDocumentActionsState, document: IDocument) {
    state.document = document;
  },
  [EDocumentActionsMutation.SetLoadDocumentFailed](state: IDocumentActionsState, failed: boolean) {
    state.loadDocumentFailed = failed;
  },
  [EDocumentActionsMutation.SetUpdatedDocument](
    state: IDocumentActionsState,
    updatedDocument: IDocument
  ) {
    state.updatedDocument = updatedDocument;
  },
  [EDocumentActionsMutation.SetNewVersionDocumentId](
    state: IDocumentActionsState,
    documentId: string
  ) {
    state.newVersionDocumentId = documentId;
  },

  [EDocumentActionsMutation.SetSentEmail](state: IDocumentActionsState, email: ISentEmail) {
    state.sentEmail = email;
  },
  [EDocumentActionsMutation.SetDocumentEvents](
    state: IDocumentActionsState,
    documentEvents: IDocumentEventItem[]
  ) {
    state.documentEvents = documentEvents;
  },
};
